<div>
    <form nz-form #attachmentPage="ngForm">
        <div nz-row class="my-box" nzGutter="5">
            <!-- <div nz-col nzSpan="24">
                <nz-form-item>
                    <nz-form-label nzNoColon>Attached Date Time</nz-form-label>

                    <nz-form-control>
                        <nz-date-picker style="width: 100%;" name="updatedDate" nzShowTime [nzShowTime]="{ nzFormat: 'HH:mm' }" nzFormat="dd/MM/yyyy hh:mm a" [(ngModel)]="data.UPDATED_DATETIME"></nz-date-picker>
                    </nz-form-control>
                </nz-form-item>
            </div> -->

            <div nz-col nzSpan="24">
                <nz-form-item>
                    <nz-form-label nzRequired nzNoColon>Attachment</nz-form-label>

                    <nz-form-control>
                        <button nz-button style="height: 28px; padding: 0px 7px; font-size: 12px;"
                            (click)="fileInput.click()">Choose File
                            <input #fileInput type="file" (change)="onFileSelected($event)"
                                (click)="fileInput.value = null" style="display: none;" />
                        </button>
                    </nz-form-control>
                </nz-form-item>
            </div>

            <div nz-col nzSpan="23" *ngIf="fileURL!=null"
                style="overflow: hidden; padding-left: 11px; font-size: 13px;">
                {{fileURL.name}}
            </div>

            <div nz-col nzSpan="1" *ngIf="fileURL!= null">
                <i nz-icon nzType="delete" (click)="clear()" [nzTheme]="'twotone'" [nzTwotoneColor]="'#ff0000'"></i>
            </div>

            <div nz-col nzSpan="24">
                <nz-form-item *ngIf="data.ID">
                    <p style="size: 10px;">{{data.ATTACHMENT_URL}}</p>
                </nz-form-item>
            </div>

            <!-- <div nz-col nzSpan="24">
                <nz-form-item>
                    <nz-form-label nzNoColon>Active</nz-form-label>

                    <nz-form-control>
                        <nz-switch name="isActive" [(ngModel)]="data.IS_ACTIVE"></nz-switch>
                    </nz-form-control>
                </nz-form-item>
            </div> -->

            <!-- <div nz-col nzSpan="12">
                <nz-form-item>
                    <nz-form-label nzRequired nzNoColon>Type</nz-form-label>

                    <nz-form-control>
                        <input nz-input name="type" type="number" min="0" oninput="this.value = Math.abs(this.value)" onkeyup="if(this.value> 60){this.value= 60}" placeHolder="Enter Seconds" [(ngModel)]="data.TYPE" required/>
                    </nz-form-control>
                </nz-form-item>
            </div>

            <div nz-col nzSpan="12">
                <nz-form-item>
                    <nz-form-label nzRequired nzNoColon>Type ID</nz-form-label>

                    <nz-form-control nzHasFeedback nzErrorTip="Spent Seconds is Required">
                        <input nz-input name="typeID" type="number" min="0" oninput="this.value = Math.abs(this.value)" onkeyup="if(this.value> 60){this.value= 60}" placeHolder="Enter Seconds" [(ngModel)]="data.TYPE_ID" required/>
                    </nz-form-control>
                </nz-form-item>
            </div> -->
        </div>
    </form>
</div>

<div class="footer">
    <button type="button" nz-button class="ant-btn" style="margin-right: 8px;"
        (click)="close(attachmentPage)"><span>Cancel</span></button>
    <button type="button" class="ant-btn ant-btn-primary" nz-button [nzLoading]="isSpinning" *ngIf="data.ID"
        (click)="save(false)"><span>Update & close</span></button>
    <button type="button" class="ant-btn ant-btn-primary" nz-dropdown [nzDropdownMenu]="menu" *ngIf="!data.ID" nz-button
        [nzLoading]="isSpinning" (click)="save(false)"><span>Save & Close</span></button>
    <nz-dropdown-menu #menu="nzDropdownMenu">
        <ul nz-menu>
            <li nz-menu-item class="menuc" style="border-radius: 4px;background-color: #40a9ff;">
                <a (click)="save(true)">Save & New</a>
            </li>
        </ul>
    </nz-dropdown-menu>

    <!-- <button type="button" nz-button class="ant-btn" style="margin-right: 8px;" (click)="resetDrawer(attachmentPage)"><span>Reset</span></button> -->
</div>